import React from "react";
import IKenoDraw from "../interfaces/IKenoDraw";
import GameBoardFooter from "./GameBoardFooter";
import GameBoardNumber from "./GameBoardNumber";

interface IProps {
    currentDraw?: IKenoDraw;
    drawnNumbers?: number[];
    highlightOddEven?: boolean;
    maxSelections?: number;
    mode: "select" | "confirm" | "draw";
    nextDraw: IKenoDraw | undefined;
    selectedNumbers: number[];
    onSelectedNumbersChange?(selectedNumbers: number[]): void;
}
interface IState {
    ticket: undefined;
}

export default class GameBoard extends React.Component<IProps, IState> {
    public state: IState = {
        ticket: undefined,
    };
    public handleNumberToggle(value: number): void {
        const { selectedNumbers, maxSelections, onSelectedNumbersChange } = this.props;

        if (!onSelectedNumbersChange) {
            return;
        }

        const newNumbers = [...selectedNumbers];
        if (!selectedNumbers.includes(value)) {
            if (maxSelections && selectedNumbers.length >= maxSelections) {
                return;
            }
            newNumbers.push(value);
        } else {
            newNumbers.splice(newNumbers.indexOf(value), 1);
        }
        onSelectedNumbersChange(newNumbers);
    }
    public render(): JSX.Element {
        const SECTIONS = 2;
        const ROWS_PER_SECTION = 4;
        const COLUMNS_PER_ROW = 10;

        const grids = [];
        const { mode, selectedNumbers, highlightOddEven } = this.props;

        const drawnNumbers = this.props.drawnNumbers || [];

        for (let section = 0; section < SECTIONS; section++) {
            const newGridRow: JSX.Element[] = [];
            grids.push(newGridRow);
            for (let row = section * ROWS_PER_SECTION; row < (section + 1) * ROWS_PER_SECTION; row++) {
                const columns: JSX.Element[] = [];
                for (let col = 0; col < COLUMNS_PER_ROW; col++) {
                    const numberValue = (row * COLUMNS_PER_ROW) + col + 1;
                    const selected = selectedNumbers ? selectedNumbers.includes(numberValue) : false;
                    const drawn = drawnNumbers.includes(numberValue);

                    columns.push(
                        <GameBoardNumber
                            key={ numberValue }
                            onToggle={ mode === "select" ? this.handleNumberToggle.bind(this) : undefined }
                            numberValue={ numberValue }
                            drawn={ drawn }
                            selected={ selected }
                        />,
                    );
                }
                if (grids[section]) {
                    grids[section].push(<tr key={ row }>{ columns }</tr>);
                }
            }
        }

        const classes = ["game-board", `${mode}-mode`];

        if (mode === "draw" && selectedNumbers.length) {
            if (highlightOddEven) {
                classes.push("done");
            }
            classes.push("has-selections");
        }

        return (
            <div className={ classes.join(" ") }>
                <table>
                    <tbody>
                        { grids[0] }
                    </tbody>
                    <tbody className="meta-section">
                        <tr>
                            <td colSpan={ COLUMNS_PER_ROW }>
                                { this.props.children }
                            </td>
                        </tr>
                    </tbody>
                    <tbody>
                        { grids[1] }
                    </tbody>
                </table>
                <GameBoardFooter />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/GameBoard.tsx